var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 276.34 430.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4e6283;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #fff;\n        stroke-dasharray: 0 0 0 0 0 0;\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "feeder"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "bg",
    className: "cls-1",
    points: "4.49 5.14 217.97 5.14 218.77 320.36 119.61 377.29 101.37 377.29 3.8 318.98 4.49 5.14"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fills"
  }, /*#__PURE__*/React.createElement("g", {
    id: "left"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "186.61 21.53 186.61 302.48 129.93 336.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "130.65 331.64 131.61 331.91 130.26 336.66 135.09 337.65 134.89 338.63 129.01 337.42 130.65 331.64"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 149.53,
    y1: 269.03,
    x2: 149.53,
    y2: 21.53
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "153.62 265.72 152.89 265.04 149.53 268.65 146.18 265.04 145.44 265.72 149.53 270.12 153.62 265.72"
  })), /*#__PURE__*/React.createElement("g", {
    id: "right"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "141.72 21.53 141.72 198.81 174.07 231.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "168.83 231.7 168.87 230.7 173.8 230.88 173.62 225.95 174.62 225.92 174.83 231.92 168.83 231.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 66.59,
    y1: 269.03,
    x2: 66.59,
    y2: 21.53
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "70.68 265.72 69.95 265.04 66.59 268.65 63.23 265.04 62.5 265.72 66.59 270.12 70.68 265.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "31 21.53 31 302.48 87.67 336.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "82.71 338.63 82.51 337.65 87.34 336.66 85.99 331.91 86.96 331.64 88.59 337.42 82.71 338.63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "timer"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 66.59,
    y1: 269.03,
    x2: 66.59,
    y2: 21.53
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "70.68 265.72 69.95 265.04 66.59 268.65 63.23 265.04 62.5 265.72 66.59 270.12 70.68 265.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "186.61 21.53 186.61 302.48 129.93 336.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "130.65 331.64 131.61 331.91 130.26 336.66 135.09 337.65 134.89 338.63 129.01 337.42 130.65 331.64"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "31 21.53 31 302.48 87.67 336.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "82.71 338.63 82.51 337.65 87.34 336.66 85.99 331.91 86.96 331.64 88.59 337.42 82.71 338.63"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 149.53,
    y1: 269.03,
    x2: 149.53,
    y2: 21.53
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "153.62 265.72 152.89 265.04 149.53 268.65 146.18 265.04 145.44 265.72 149.53 270.12 153.62 265.72"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gravity"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "141.72 21.53 141.72 198.81 174.07 231.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "168.83 231.7 168.87 230.7 173.8 230.88 173.62 225.95 174.62 225.92 174.83 231.92 168.83 231.7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "outline"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.47,377.62H3.53V3.98h215.94v373.64h0ZM4.76,376.39h213.48V5.2H4.76v371.18h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 110.89,
    y: 4.59,
    width: 1.23,
    height: 207.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.34,319.95h-58.09v-66.53l58.09,31.91v34.62ZM219.48,318.72h55.63v-32.66l-55.63-30.56v63.22h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "223.88 8.56 222.65 8.56 222.65 1.23 1.23 1.23 1.23 8.56 0 8.56 0 0 223.88 0 223.88 8.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M124.8,387.23h-28.46v-10.84h28.46v10.84h0ZM97.57,386h26v-8.38h-26v8.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "118.17 383.36 103.37 383.36 100.53 377.26 101.65 376.74 104.15 382.13 117.38 382.13 119.89 376.74 121 377.26 118.17 383.36"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 34.88,
    y: 377,
    width: 3.74,
    height: 18.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 183.31,
    y: 377,
    width: 3.74,
    height: 18.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.93,
    y: 394.95,
    width: 183.14,
    height: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.72,377v26.7c0,2.4,1.33,1.87,4.27,1.87s31.1.08,38.9.27c10.98.27,16.13,11.21,16.13,16.82,0,2.41.95,2.66,2.8,2.66h5.34v-5.07h-3.74s-2.85-17.81-20.47-18.81c-8.47-.48-15.2-.28-23.74-.28h-13.88c-.8,0-1.33-1.47-1.33-3.34v-20.82s-4.28,0-4.28,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M113.78,391.9h-6.97v-5.9h6.97v5.9ZM108.04,390.67h4.51v-3.44h-4.51v3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M115.25,396.04h-9.91v-3.9h9.91v3.9ZM106.57,394.81h7.45v-1.44h-7.45v1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.11,396.04h-3.9v-3.9h3.9v3.9ZM100.44,394.81h1.44v-1.44h-1.44v1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121.93,396.04h-3.9v-3.9h3.9v3.9ZM119.26,394.81h1.44v-1.44h-1.44v1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M129.94,430.74h-38.34v-35.94h38.34v35.94ZM92.83,429.51h35.88v-33.48h-35.88v33.48Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 98.3,
    y: 395.42,
    width: 24.84,
    height: 27.23
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "120.75 377.53 120.13 376.47 218.54 319.42 219.16 320.48 120.75 377.53"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 51.83,
    y: 291.31,
    width: 1.23,
    height: 113.33,
    transform: "translate(-273.28 214.79) rotate(-59.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.51,215.69c-1.14,0-2.07-.93-2.07-2.07s.93-2.07,2.07-2.07,2.07.93,2.07,2.07-.93,2.07-2.07,2.07ZM111.51,212.78c-.46,0-.84.38-.84.84s.38.84.84.84.84-.38.84-.84-.38-.84-.84-.84Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModes);
export default __webpack_public_path__ + "static/media/modes.c2125295c37e59dfe17f903c061c4504.svg";
export { ForwardRef as ReactComponent };